import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/info_icon.svg'
import _imports_1 from '@/assets/close_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-475c87a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "menu"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" This is a tool to measure the effect of the "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://en.wikipedia.org/wiki/Attentional_blink" }, "attentional blink")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " A sequence of characters will flash in the square, with two digits mixed in between. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Fill in the two digits in the inputs below the big square", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Click on the big square to start the test", -1))

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isOpen.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_0,
          alt: "Settings icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true))
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("img", {
            src: _imports_1,
            alt: "Close icon",
            class: "closeIcon",
            width: "48",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false))
          })
        ]))
  ]))
}
}

})